export default __webpack_public_path__ + "images/b6013da96111c2ec9d3ea66cb7c0d797-pageNotFound--dark.png";